<script lang="ts">
	import type { SvelteAsr } from 'types/common'
	import type { i18n } from 'types/common'

	import { hasPermission } from 'utility/permission'
	import Button from '@isoftdata/svelte-button'
	import Input from '@isoftdata/svelte-input'
	import Popover from '@isoftdata/svelte-popover'
	import StateCardHeader from 'components/StateCardHeader.svelte'
	import { onMount } from 'svelte'
	import { getContext } from 'svelte'

	interface Props {
		asr: SvelteAsr
		searchKeyword?: string
	}

	let { asr, searchKeyword = $bindable('') }: Props = $props()

	let searchInput: HTMLInputElement | undefined = $state()

	const { t: translate } = getContext<i18n>('i18next')

	onMount(() => {
		console.log('mount')
		searchInput?.focus()
	})
</script>

<div class="card">
	<StateCardHeader
		icon="user"
		title={translate('common:vendorSearch', 'Vendor Search')}
	>
		{#snippet right()}
			{#if hasPermission('VENDORS_CAN_EDIT_VENDORS')}
				<Button
					outline
					size="sm"
					color="success"
					iconClass="plus"
					href={asr.makePath('app.vendor')}
				>
					{translate('common:newvendor', 'New Vendor')}
				</Button>
			{/if}
		{/snippet}
	</StateCardHeader>
	<div class="card-body">
		<form
			id="search-field-form"
			onsubmit={event => {
				event.preventDefault()
				asr.go('app.vendor-search.results', { keyword: searchKeyword })
			}}
		>
			<Input
				showLabel={false}
				size=""
				labelParentClass="mb-0"
				placeholder="Keyword Search"
				bind:value={searchKeyword}
				bind:input={searchInput}
			>
				{#snippet append()}
					<Popover
						outline
						autoUpdate
						color="secondary"
						iconClass="info-circle"
						style="border-top-right-radius: 0.2rem; border-bottom-right-radius: 0.2rem;"
					>
						{#snippet content()}
							<h6 class="popover-header">{translate('vendorSearch.searchFiltersBy', 'Search Filters By')}:</h6>
							<div class="popover-body">
								<ul class="mb-0 ps-3">
									<li class="text-nowrap">{translate('common:companyName', 'Company Name')}</li>
									<li class="text-nowrap">{translate('common:contactName', 'Contact Name')}</li>
									<li class="text-nowrap">{translate('common:phoneNumber', 'Phone Number')}</li>
								</ul>
							</div>
						{/snippet}
					</Popover>
				{/snippet}
			</Input>
		</form>
	</div>

	<div class="card-footer d-flex justify-content-end border-bottom">
		<Button
			type="submit"
			form="search-field-form"
			iconClass="search"
			size="sm"
		>
			{translate('common:searchVendor', 'Search Vendors')}
		</Button>
	</div>
</div>

<uiView></uiView>
